<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <!-- 搜索/导航 -->
    <YorkbbsSearchNav :topTopic="topTopic"></YorkbbsSearchNav>

    <div class="page-wrapper">
      <!-- 探店/采访专栏 美食列表专属 -->
      <!-- <YorkbbsColumn v-if="isFoodTopic"></YorkbbsColumn> -->

      <!-- 分类、城市筛选 -->
      <YorkbbsCateNav @topicChange="onTopicChange"></YorkbbsCateNav>
    </div>

    <div class="page-wrapper main">
      <div class="page-left">
        <!-- 选项卡 -->
        <div class="tab">
          <div class="tab-left">
            <h1 class="tab-name">{{ currentTopic.name }}</h1>
          </div>
          <div class="tab-right">
            <YorkbbsSortMenu :list="sortTypes" v-model="sortTypeIndex" @change="onSortTypeChange"></YorkbbsSortMenu>
          </div>
        </div>

        <!-- 列表 -->
        <div class="info-list">
          <YorkbbsInfoItem
            v-for="(item, i) in post.list"
            :key="i"
            :data="item"
            :index="i"
            :indexVisible="sortTypeIndex == 0"
          ></YorkbbsInfoItem>
        </div>

        <!-- 无结果 -->
        <YorkbbsEmptyResult v-if="!post.loading && post.list.length == 0"></YorkbbsEmptyResult>

        <!-- 分页 -->
        <YorkbbsPagination
          :current-page="post.offset"
          :page-size="post.size"
          :total="post.itemTotal"
          hide-on-single-page
          @current-change="pageChange"
        ></YorkbbsPagination>
      </div>
      <div class="page-right">
        <!-- 广告 -->
        <div class="kjwt-column">
          <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`right_${i}`]"></YorkbbsAdvItem>
        </div>

        

        <YorkbbsAffix :top="10" @onScroll="onScroll" :style="{ visibility: advIsFixed ? 'visible' : 'hidden' }">
          <!-- 广告 -->
          <div class="kjwt-column">
            <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`right_${i}`]"></YorkbbsAdvItem>
          </div>
        </YorkbbsAffix>

        <!-- 攻略/榜单/专题 美食类显示 -->
        <!-- <YorkbbsRank v-if="isFoodTopic"></YorkbbsRank> -->

        <!-- 最新入驻商家 美食类显示 -->
        <!-- <YorkbbsNewShop v-if="isFoodTopic"></YorkbbsNewShop> -->
      </div>
    </div>

    <!-- 返回顶部 -->
    <YorkbbsBackup
      :publishVisible="true"
      :publishTitle="'免费发布'"
      :publishURL="'/publish'"
      :merchantVisible="true"
      :opinionVisible="true"
    ></YorkbbsBackup>

    <!-- 底部 -->
    <YorkbbsFooter></YorkbbsFooter>
  </div>
</template>
<script>
import { bannerAdvConvert, setHtmlMeta } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearchNav from '../components/search-nav.vue';
import YorkbbsSortMenu from '../components/menu-sort.vue';
import YorkbbsCateNav from './cate-nav.vue';
import YorkbbsInfoItem from '../components/item-info.vue';
import YorkbbsEmptyResult from '@/common/empty-result/empty-result.vue';
import YorkbbsPagination from '@/common/pagination.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsAdvItem from '@/common/item-adv.vue';
import YorkbbsAffix from '@/common/affix.vue';
export default {
  name: 'List',
  components: {
    YorkbbsHeader,
    YorkbbsSearchNav,
    YorkbbsSortMenu,
    YorkbbsCateNav,
    YorkbbsInfoItem,
    YorkbbsEmptyResult,
    YorkbbsPagination,
    YorkbbsFooter,
    YorkbbsBackup,
    YorkbbsAdvItem,
    YorkbbsAffix,
  },
  data() {
    return {
      // 黄页信息
      post: {
        loading: false,
        offset: 1,
        size: 100,
        itemTotal: 0,
        list: [],
        distance: undefined,
        longitude: undefined,
        latitude: undefined,
      },
      // 一级版块信息
      topTopic: {},
      // 当前版块信息（一级或二级）
      currentTopic: {},
      // 广告列表
      ads: [
        { image: 'common/images/ad_300_01.png' },
        { image: 'common/images/ad_300_02.png' },
        { image: 'common/images/ad_300_03.png' },
      ],
      // 排序列表
      sortTypes: [
        {
          name: '智能排序',
        },
        { name: '热门排序', value: ['property_payType:ASC','property_view:DESC'] },
      ],
      // 当前排序索引
      sortTypeIndex: 0,

      // 广告
      adv: {},

      advIsFixed: false,
    };
  },
  computed: {
    // 是否是美食板块
    isFoodTopic() {
      return this.topTopic.englishName == 'restaurants';
    },
  },
  created() {
    const offset = Number(this.$route.query.offset);
    const sort = Number(this.$route.query.sort);

    this.post.offset = Number.isNaN(offset) ? 1 : offset;
    this.sortTypeIndex = Number.isNaN(sort) ? 0 : sort;

    this.getPostList();

    this.getAdvList();
  },
  methods: {
    // 获取黄页列表
    async getPostList() {
      this.post.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/post/list', {
          offset: this.post.offset,
          size: this.post.size,
          topicEngName: this.$route.params.topic,
          options: {
            cityId: this.$route.query.city && [this.$route.query.city],
            sort: this.sortTypes[this.sortTypeIndex]['value'],
          },
          longitude: this.post.longitude,
          latitude: this.post.latitude,
          distance: 50000000,
        })
        .finally(() => {
          this.post.loading = false;
        });

      data.items.forEach(item => {
        // 处理店名和标题相同
        if (item.title == item.property.shopCnName) {
          item.property.shopCnName = '';
        }
      });

      this.post.list = data.items;
      this.post.itemTotal = data.itemTotal;

      
    },

    /**
     * 排序发生变化
     */
    onSortTypeChange(sortType) {
      this.$router.push({ query: { ...this.$route.query, offset: 1, sort: sortType } });
    },
    // 翻页
    pageChange(offset) {
      this.post.offset = offset;
      this.$router.push({ query: { ...this.$route.query, offset } });
    },
    /**
     * 切换板块
     */
    onTopicChange({ top, current }) {
      this.topTopic = top;
      this.currentTopic = current;
    },
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 992809558;
      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId });

      this.adv = bannerAdvConvert(data, 'info', zoomId);
      console.log(this.adv);
    },

    onScroll({ isFixed }) {
      this.advIsFixed = isFixed;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  width: 1170px;
  margin: auto;
  &.main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
}
.page-left {
  width: 830px;
  min-height: 500px;
}
.page-right {
  width: 300px;
}

.tab {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
  border-bottom: 1px solid #ddd;
}
.tab-left,
.tab-right {
  display: flex;
  align-items: center;
}

.tab-name {
  font-size: 18px;
  line-height: 25px;
  font-weight: 600;
}
.button-map {
  font-size: 14px;
  color: var(--primary-color);
  margin-left: 20px;
  i {
    font-size: 12px;
    margin-right: 5px;
  }
}

::v-deep {
  .kjwt-column {
    .kjwt-item {
      margin-bottom: 10px;
    }
  }

  .kjwt-row {
    width: 1170px;
    display: flex;
    margin: 0 auto;
    .kjwt-item {
      margin: 10px 0;
    }

    .kjwt-item + .kjwt-item {
      margin-left: 10px;
    }
  }
}
</style>
